export default __webpack_public_path__ + "c52f0904ad34b0ecc45374165175535c.glb";